import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex space-x-2" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "pt-1 text-xs font-semibold text-neutral-600" }, "Is field required?", -1)

import { ref } from "vue";
import ToggleSwitch from "@/components/inputs/ToggleSwitch.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'RequiredSwitch',
  props: {
	form: {
		type: Object,
	},
    value: {
        default: null,
        required: true,
    },
    label: {
        type: String,
        default: null,
    },
    description: {
        type: String,
        default: null,
    },
    noPadding: {
        type: Boolean,
        default: false
    },
    error: {
        type: String,
        default: null,
    },
    disabled: {
        type: Boolean,
        default: false,
    },
},
  setup(__props) {

const props = __props;
const form = ref<object>(props.form);
const switchData = ref<boolean>(false);



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(ToggleSwitch, {
      value: switchData.value,
      noPadding: "",
      onChange: _cache[0] || (_cache[0] = ($event: any) => (
                switchData.value = !switchData.value
            ))
    }, null, 8, ["value"]),
    _hoisted_2
  ]))
}
}

})